import * as React from "react";
import { SearchProvider } from "../components/search/search-context";
import { SidebarProvider } from "./sidebar-provider";
import { NotificationProvider } from "./notification-provider";
import DialogProvider from "./dialog-provider";
import { StepperProvider } from "./stepper-provider";

export interface CustomProvidersProps {
  children: React.ReactNode;
}

const CustomProviders = ({ children }: CustomProvidersProps) => {
  return (
    <DialogProvider>
      <NotificationProvider>
        <SidebarProvider>
          <StepperProvider>
            <SearchProvider>{children}</SearchProvider>
          </StepperProvider>
        </SidebarProvider>
      </NotificationProvider>
    </DialogProvider>
  );
};

export default CustomProviders;
